import _ from 'underscore';

/**
 * Create a regex from a route path by replacing parameters by patterns
 * ie. /event/:id => /event/\w+
 * @param {string} pathname
 */
export function getRegexFromPath(pathname, strict = false) {
    return new RegExp(`^${pathname.replace(/:\w+/ig, '[-[\\]\\w]+')}${strict ? '$' : ''}`);
}

/**
 * Extract the query parameters from a string
 * ie. ?param1=hello&param2=world => { param1: 'hello', param2: 'world' }
 * @param {string} query
 * @return {object}
 */
export function extractQueryParameters(query) {
    const urlSearchParams = new URLSearchParams(query[0] === '?' ? query.slice(1) : query);
    const params = {};
    // eslint-disable-next-line no-restricted-syntax
    for (const key of urlSearchParams.keys()) {
        params[key] = urlSearchParams.get(key);
    }
    return params;
}

/**
 * Build the query parameters from an object
 * ie. { param1: 'hello', param2: 'world' } => param1=hello&param2=world
 * @param {object} parameters
 * @return {string}
 */
export function buildQueryParameters(parameters) {
    const queryParameters = new URLSearchParams();
    _.each(Object.keys(parameters), (parameterKey) => {
        queryParameters.append(parameterKey, parameters[parameterKey]);
    });
    return queryParameters.toString();
}

/**
 * Retrieve the current route from a link
 * @param {string} pathname The current pathname
 * @param {array} Routes The routes
 * @returns {object} The route object
 */
export function getRoutesFromLink(pathname, Routes) {
    return _.find(Routes, (route) => getRegexFromPath(route.link).test(pathname));
}

/**
 * Generate a valid route by replacing placeholders
 * @param {string} route The route with potential placeholders
 * @param {object} parameters the placeholder replacements
 * @returns {string} The generated route
 */
export function buildRoute(route, parameters = {}) {
    return _.reduce(Object.keys(parameters), (previousRoute, key) => (
        previousRoute.replace(`:${key}`, parameters[key])
    ), route);
}
